import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TermsUserPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="card p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">
          {t('terms.title')}
        </h1>

        <div className="prose prose-sm max-w-none">
          <p className="mb-6 text-gray-700">
            {t('terms.intro')}
          </p>

          <>
            <h2 className="text-lg font-semibold mb-2">{t('terms.1.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('terms.1.item.purpose')}</li>
            </ul>
            <br />

            <h2 className="text-lg font-semibold mb-2">{t('terms.2.title')}</h2>
            <ul className="list-disc pl-5 mb-2">
              <li>{t('terms.2.item.prohibited')}</li>
            </ul>            

            <ul className="pl-6 mb-4">
              <li>1. {t('terms.2.item.illegal')}</li>
              <li>2. {t('terms.2.item.rights')}</li>
              <li>3. {t('terms.2.item.spam')}</li>
            </ul>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('terms.2.item.consequence')}</li>
            </ul>
            <br />

            <h2 className="text-lg font-semibold mb-2">{t('terms.3.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('terms.3.item.monitoring')}</li>
              <li>{t('terms.3.item.deletion')}</li>
              <li>{t('terms.3.item.features')}</li>
              <ul className="mt-2">
                <li>1. {t('terms.3.item.flagging')}</li>
                <li>2. {t('terms.3.item.blocking')}</li>
              </ul>
            </ul>
            <br />

            <h2 className="text-lg font-semibold mb-2">{t('terms.4.title')}</h2>
            <ul className="list-disc pl-5 mb-4">
              <li>{t('terms.4.item.liability')}</li>
            </ul>
          </>
        </div>
      </div>
    </div>
  );
};

export default TermsUserPage;


